import { ItiHttpService } from "@/iti-core-react/services/iti-http-service";
import { API } from "../api";
import { DatasetFilterDtoV2 } from "../dtos/Governance/dataset-filter-dto-v2";
import { DatasetSearchResultPageDtoV2 } from "../dtos/Governance/dataset-search-result-page-dto-v2";
import { CatalogueSearchFilterDto } from "../dtos/catalogue-search-filter-dto";

export const SearchService = {
	async search(
		options: CatalogueSearchFilterDto,
	): Promise<DatasetSearchResultPageDtoV2> {
		return ItiHttpService.post(
			`${API.governance.search}`,
			options.toJson(["value", "previousValue"]),
			true,
		);
	},
	async searchRecycleDatasets(
		dto: DatasetFilterDtoV2,
	): Promise<DatasetSearchResultPageDtoV2> {
		return await ItiHttpService.post(`${API.governance.search}`, dto, true);
	},
};
